/**
 * This component just glues the redux-forms and Datetime components together
 */
import React from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';

import styles from './styles.sass';

const getCurrentDateAtUpcomingHour = () =>
  moment()
    .add(59, 'minutes')
    .startOf('hour');

const FieldDatetime = props => {
  const {
    input: { onChange, value },
    meta: { error, touched },
    name,
  } = props;
  const dateTimeValue =
    !value || value === '' ? getCurrentDateAtUpcomingHour() : value;
  return (
    <Datetime
      className={styles.DatetimeContainer}
      name={name}
      input={false}
      timeConstraints={{
        minutes: { min: 0, max: 0, step: 60 },
        seconds: { min: 0, max: 0, step: 60 },
        milliseconds: { min: 0, max: 0, step: 1000 },
      }}
      onChange={onChange}
      value={dateTimeValue}
    />
  );
};

export default FieldDatetime;
